import { detailViewSlice } from './detail-view';
export const detailViewActions = detailViewSlice.actions;

export const { reducer: detailViewReducer } = detailViewSlice;
export * from './types';
